import { ArrowLeft, FileText, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./LegalPages.css";
import { Helmet } from "react-helmet-async";

export function Terms() {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
      <title>{t("seo.terms.title")}</title>

      <meta
        name="description"
        content={t("seo.terms.description")}
      />

      <link
        rel="canonical"
        href="https://francescotransfers.com/terms"
      />
    </Helmet>
    <main className="legal-page">
      <div className="legal-page-container">
        <Link to="/" className="legal-back-link">
          <ArrowLeft size={18} />
          <span>{t("terms.back")}</span>
        </Link>

        <header className="legal-header">
          <div className="legal-icon">
            <FileText size={30} />
          </div>

          <div>
            <span className="legal-eyebrow">
              {t("terms.eyebrow")}
            </span>

            <h1>{t("terms.title")}</h1>

            <p>{t("terms.intro")}</p>
          </div>
        </header>

        <div className="legal-content">
          <section className="legal-section">
            <h2>{t("terms.bookings.title")}</h2>
            <p>{t("terms.bookings.description")}</p>
          </section>

          <section className="legal-section">
            <h2>{t("terms.payments.title")}</h2>
            <p>{t("terms.payments.description")}</p>
          </section>

          <section className="legal-section">
            <h2>{t("terms.cancellations.title")}</h2>
            <p>{t("terms.cancellations.description")}</p>
          </section>

          <section className="legal-section">
            <h2>{t("terms.liability.title")}</h2>
            <p>{t("terms.liability.description")}</p>
          </section>

          <section className="legal-section">
            <h2>{t("terms.changes.title")}</h2>
            <p>{t("terms.changes.description")}</p>
          </section>

          <aside className="legal-notice">
            <ShieldCheck size={22} />

            <div>
              <strong>{t("terms.notice.title")}</strong>
              <p>{t("terms.notice.description")}</p>
            </div>
          </aside>

          <p className="legal-updated">
            {t("terms.lastUpdated")}
          </p>
        </div>
      </div>
    </main>
    </>
  );
}